export const API_URL = process.env.REACT_APP_BACKEND_URL
const endpoints = {
  // Auth
  SIGN_IN: API_URL + "/api/v1/auth/signin",
  PROFILE: (userId: any) => API_URL + `/api/v1/users/${userId}`,
  FORGOT_PASSWORD: API_URL + "/api/v1/auth/forgot-password",
  RESET_PASSWORD: API_URL + "/api/v1/auth/reset-password",
  EDIT_PROFILE: (userId: any) => API_URL + `/api/v1/users/${userId}`,
  CHANGE_PASSWORD: API_URL + "/api/v1/users/change-password",

  // Role
  VIEW_LIST_ROLE: API_URL + "/api/v1/roles",
  
  // Purchase
  PURCHASE: API_URL + "/api/v1/purchases",

  // Region
  REGION: API_URL + "/api/v1/regions",

  // Forecast
  FORECAST: API_URL + "/api/v1/forecasts",

  // Users
  USERS: API_URL + "/api/v1/users",
  SEARCH_LIST_USER: API_URL + "/api/v1/admin/search-users",
  CREATE_USER: API_URL + "/api/v1/users",
  VIEW_USER: (viewId: any) => API_URL + `/api/v1/users/${viewId}`,
};

export default endpoints;
